import { toggleOrgAdminUserRolesInputsVisibility } from "./toggleOrgAdminUserRolesInputsVisibility";
import { syncPreferredName } from "./syncPreferredName";
import { toggleDriverQualificationInputs } from "./toggleDriverQualificationInputs";
import { toggleDriverOnlyFields } from "./toggleDriverOnlyFields";

type Inputs = {
    organizationRolesElement: HTMLElement;
    globalRoleInputElement: NodeListOf<HTMLInputElement>;
    fullNameInputElement: HTMLInputElement | null;
    preferredNameInputElement: HTMLInputElement | null;
    driverRoleInputElement: HTMLInputElement | null;
    driverQualificationInputElements: NodeListOf<HTMLInputElement>;
    driverOnlyFieldElements: NodeListOf<HTMLElement>;
}
export function initialize({
    organizationRolesElement,
    globalRoleInputElement,
    fullNameInputElement,
    preferredNameInputElement,
    driverRoleInputElement,
    driverQualificationInputElements,
    driverOnlyFieldElements,
}: Inputs) {
    toggleOrgAdminUserRolesInputsVisibility({ organizationRolesElement, globalRoleInputElement })
    syncPreferredName({ fullNameInputElement, preferredNameInputElement })
    toggleDriverQualificationInputs({ driverRoleInputElement, driverQualificationInputElements })
    toggleDriverOnlyFields({ driverRoleInputElement, driverOnlyFieldElements })
}
